export function formatCurrency(value) {
  const num = parseFloat(value);
  return isNaN(num)
    ? '0.00'
    : num.toLocaleString('id-ID', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}


export function formatDateTime(value) {
  if (!value) return '—';
  return new Date(value).toLocaleString('id-ID', { dateStyle: 'medium', timeStyle: 'short' });
}